import type { ShowPopupOptions, ShowPopupOptionsButton } from '../../bootstrap/tmaActions';

const DEFAULT_BUTTONS: ShowPopupOptionsButton[] = [{ type: 'close' }];

export type ConfirmButtonKind = 'default' | 'destructive' | 'ok' | 'close' | 'cancel';

export interface ConfirmButton {
  id: string | null;
  kind: ConfirmButtonKind;
  text?: string;
}

export const isRefusalButton = (button: ConfirmButton): boolean =>
  button.kind === 'cancel' || button.id === 'cancel';

export const confirmAnswerId = (button: ConfirmButton): string | null => {
  if (button.id) return button.id;
  return button.kind === 'default' || button.kind === 'destructive' ? null : button.kind;
};

export function confirmButtons(options: ShowPopupOptions): ConfirmButton[] {
  const raw = options.buttons?.length ? options.buttons : DEFAULT_BUTTONS;
  const parsed: ConfirmButton[] = raw.map((button) => ({
    id: button.id ?? null,
    kind: 'text' in button ? (button.type ?? 'default') : button.type,
    text: 'text' in button ? button.text : undefined,
  }));
  return [...parsed.filter(isRefusalButton), ...parsed.filter((b) => !isRefusalButton(b))];
}

export function dismissAnswer(options: ShowPopupOptions): string | null {
  const buttons = confirmButtons(options);
  if (buttons.length === 1) return confirmAnswerId(buttons[0]);
  const refusal = buttons.find(isRefusalButton);
  return refusal ? (refusal.id ?? 'cancel') : null;
}
